import { Controller } from 'react-hook-form'
import { cleanAccentsAndDiacritics } from '../../../../utils/stringUtils'
import PatientFormField from '../PatientFormField'
import { useFormContextPatient, validateUnrequiredStringValue } from '../_utils'

const FirstName = () => {
    const { control } = useFormContextPatient()

    return (
        <Controller
            control={control}
            name="firstName"
            rules={{
                validate: validateUnrequiredStringValue,
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="input"
                    label="Prénom utilisé"
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    placeholder="Prénom utilisé"
                    dataCyScope="PatientField"
                    {...field}
                    value={cleanAccentsAndDiacritics(String(field?.value?.toUpperCase() ?? ''))}
                    onKeyUp={(event) => {
                        const capitalize = String(field.value).toUpperCase()
                        const cleanInput = cleanAccentsAndDiacritics(capitalize)
                        event.currentTarget.value = cleanInput
                    }}
                />
            )}
        />
    )
}

export default FirstName
